const baseUrl = process.env.NODE_ENV === "production" ? "/" : "http://localhost:60428"
const languages = [{ name: "English", code: "en" }, { name: "Vietnamese", code: "vi" }]
const currency = "$"
// need to update recaptcha domain once moved to production
const recaptchaKey = "6LecErsUAAAAAMxrJ8pYANodfrmSJBiJqhu-Ime2"

const recaptchaV3SiteKey = "6Ld4NLwUAAAAADAwVKDpdonWXzokPPz3eiBW-9OY"
const appStoreUrl = "#"
const ggStoreUrl = "#"
const maxTransferAmount = 5000000
const timeoutConfigs = {
	warnTimeoutMins: 1.5,
	logoutTimeoutMins: 5,
	refreshIntervalMins: 8,
}
const captchaThreshold = 0
const noOfStarsForFreeDrink = 25
const qrCodePrefix = "https://www.jfh.com/sg/?cardno="
const herokuPassword = "asc_JFH@2019"
const gmapsAPI = "asfDWD9793"

export {
	baseUrl,
	languages,
	currency,
	recaptchaKey,
	maxTransferAmount,
	appStoreUrl,
	ggStoreUrl,
	timeoutConfigs,
	captchaThreshold,
	noOfStarsForFreeDrink,
	herokuPassword,
	qrCodePrefix,
	recaptchaV3SiteKey,
}



// WEBPACK FOOTER //
// ./src/configs/Settings.js